import http from '../../HttpConfig'
import {APIS_ENDPOINTS} from '../../SERVICE-CONSTANTS'

const zament_endpoints = APIS_ENDPOINTS.requestZamen

interface IZamentCountPayload {
  RequestId: number
  ZamenCount: number
  ZamenPlaceCount: number
  ZamenLegalCount: number
  isSendZamen: boolean
  sendPlace: boolean
  sendLegal: boolean
}

export const request_sendzamencount = async ({
  RequestId,
  ZamenCount,
  ZamenPlaceCount,
  ZamenLegalCount,
  isSendZamen,
  sendPlace,
  sendLegal
}: IZamentCountPayload) => {
  const formData = new FormData()
  formData.append('RequestId', RequestId.toString())
  formData.append('ZamenCount', ZamenCount.toString())
  formData.append('ZamenPlaceCount', ZamenPlaceCount.toString())
  formData.append('ZamenLegalCount', ZamenLegalCount.toString())
  formData.append('IsSendZamen', isSendZamen.toString())
  formData.append('SendPlace', sendPlace.toString())
  formData.append('SendLegal', sendLegal.toString())

  return http.put(zament_endpoints.sendzamencount, formData)
}


export const request_getallzamenbyrequestid = async ({
  RequestId,
  ZamenType,
}: {
  RequestId: number
  ZamenType?: number
}) => {
  return http.get(zament_endpoints.getallzamenbyrequestidpanel + '?RequestId=' + RequestId)
}

export const request_chanegzamenstatus = async ({
  Id,
  ZamenStatus,
}: {
  Id: number
  ZamenStatus: number
}) => {

  return http.put(zament_endpoints.chanegzamenstatus + '?Id=' + Id + '&ZamenStatus=' + ZamenStatus)
}
export const request_chanegzamenstatuslegal = async ({
  Id,
  ZamenStatus,
}: {
  Id: number
  ZamenStatus: number
}) => {

  return http.put(zament_endpoints.chanegzamenstatuslegal + '?Id=' + Id + '&ZamenStatus=' + ZamenStatus)
}
export const request_chanegzamenstatusplace = async ({
  Id,
  ZamenStatus,
}: {
  Id: number
  ZamenStatus: number
}) => {

  return http.put(zament_endpoints.chanegzamenstatusplace + '?Id=' + Id + '&ZamenStatus=' + ZamenStatus)
}

export const request_getallzamenbyrequestidpanelplace = async ({
  RequestId,
}: {
  RequestId: number
}) => {
  return http.get(zament_endpoints.getallzamenbyrequestidpanelplace + '?RequestId=' + RequestId)
}

export const request_getallzamenbyrequestidpanellegal = async ({
  RequestId,
}: {
  RequestId: number
}) => {
  return http.get(zament_endpoints.getallzamenbyrequestidpanellegal + '?RequestId=' + RequestId)
}

// +
//       '&ZamenType=' +
//       (ZamenType === undefined ? '' : ZamenType)
